import React, { createContext, useContext, useState } from 'react';
import { IssueItem } from '../models/issueItem';

interface IssuesCacheContextProps {
  issues: IssueItem[] | null;
  setIssues: (issues: IssueItem[]) => void;
}

const IssuesCacheContext = createContext<IssuesCacheContextProps | undefined>(undefined);

export const useIssuesCache = () => {
  const context = useContext(IssuesCacheContext);
  if (!context) {
    throw new Error('useIssuesCache must be used within an IssuesCacheProvider');
  }
  return context;
};

export const IssuesCacheProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [issues, setIssues] = useState<IssueItem[] | null>(null);

  const value: IssuesCacheContextProps = {
    issues,
    setIssues,
  };

  return <IssuesCacheContext.Provider value={value}>{children}</IssuesCacheContext.Provider>;
};
